import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Api } from '../api/Api';
import { ServerUrl } from '../api/ServerUrl';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';

const PrevArrow = ({ onClick }) => (
    <button type="button" className="banner-slider-arrow banner-slider-arrow-prev" onClick={onClick} aria-label="Previous slide">
        <FaChevronLeft />
    </button>
);

const NextArrow = ({ onClick }) => (
    <button type="button" className="banner-slider-arrow banner-slider-arrow-next" onClick={onClick} aria-label="Next slide">
        <FaChevronRight />
    </button>
);

const Banner = () => {
    const { http } = Api();
    const [banners, setBanners] = useState([]);
    const [notice, setNotice] = useState([]);

    useEffect(() => {
        http.get('/front-get-banner')
            .then(res => {
                setBanners(res.data);
            })
            .catch(error => {
                console.error('Error fetching users:', error);
            });
    }, []);

    useEffect(() => {
        http.get('/front-get-notice')
            .then(res => {
                setNotice(res.data);
            })
            .catch(error => {
                console.error('Error fetching users:', error);
            });
    }, []);

    const sliderSettings = {
        dots: false,
        infinite: banners.length > 1,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: banners.length > 1,
        autoplaySpeed: 5000,
        arrows: banners.length > 1,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    };

    return (
        <div>
            <section className="main-slider image-only-slider">
                {banners.length > 0 &&
                    <Slider {...sliderSettings}>
                        {banners.map((banner) => (
                            <div className="slider-box" key={banner.id}>
                                <img
                                    src={`${ServerUrl}/backend/img/${banner.banner}`}
                                    className="bannerImg"
                                    alt={banner.bannerTitle}
                                />
                            </div>
                        ))}
                    </Slider>
                }
            </section>

            {notice.note &&
                <div className="noteboxfront">
                    <section className='topMessage shadow-lg'>
                        <div className="topMessageBox py-2 mx-5 px-5 pt-3">
                            <p>{notice.note}</p>
                        </div>
                    </section>

                    <div className="container py-4 MessageBoxSmall">
                        <section className='topMessageSmall p-3 rounded'>
                            <div className="topMessageBoxSmall">
                                <p>{notice.note}</p>
                            </div>
                        </section>
                    </div>
                </div>
            }
        </div>
    );
}

export default Banner;
